import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as homestayActions from './../../../../../actions/homestayAction';
import * as locationActions from './../../../../../actions/locationAction';
import * as golfActions from './../../../../../actions/golfAction';
import {uploadAction} from './../../../../../actions/uploadAction';
import {getListProvinces} from './../../../../../actions/generalAction';
import * as amenityActions from './../../../../../actions/amenityAction';
import GolfDetail from './GolfDetail';

const mapStateToProps = state => {
    return {
        golfState: state.golfReducer,
        uploadState: state.uploadReducer,
        generalState: state.generalReducer,
        locationState: state.locationReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        getGolfDetail: (id) => dispatch(golfActions.getGolfDetail(id)),
        setGolfDetail: (golf) => dispatch(golfActions.setGolfDetail(golf)),
        updateGolfDetail: (golf) => dispatch(golfActions.updateGolfDetail(golf)),
        // createHomestayDetail: (homestay) => dispatch(homestayActions.createHomestayDetail(homestay)),
        getListLocations: (filters) => dispatch(locationActions.getListLocations(filters)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
        getProvinces: () => dispatch(getListProvinces()),
        createGolfTranslate: (golf, language) => dispatch(golfActions.createGolfTranslate(golf, language)),
        updateGolfTranslate: (golf, language) => dispatch(golfActions.updateGolfTranslate(golf, language)),
        deleteGolfTranslate: (golf, refreshParams) => dispatch(golfActions.deleteGolfTranslate(golf, refreshParams)),
        // getTagGroupDetailSku: (id) => dispatch(homestayActions.getTagGroupDetailSku(id)),
        // setTagGroupDetailSku: (data) => dispatch(homestayActions.setTagGroupDetailSku(data)),
        // updateTagGroupDetailSkuActive: (tagsGroup, id) => dispatch(homestayActions.updateTagGroupDetailSkuActive(tagsGroup, id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GolfDetail));
